import { CommonLayoutModule } from '@aiwyn/common/layout';
import { LoadableStatus, SharedModule } from '@aiwyn/shared';
import { CommonModule } from '@angular/common';
import { AfterViewChecked, AfterViewInit, Component, DestroyRef, ElementRef, inject, input, output, ViewChild } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { EngagementListItem } from '../../../../api/models';
import { PaginationOptions } from '../engagements-table/engagements-table.component';
import { EngagementCardItemComponent } from '../engagement-card-item/engagement-card-item.component';

@Component({
  selector: 'app-engagements-card-list',
  templateUrl: './engagements-card-list.component.html',
  styleUrls: ['./engagements-card-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CommonLayoutModule,
    SharedModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatProgressSpinner,
    EngagementCardItemComponent,
  ],
})
export class EngagementsCardListComponent implements AfterViewInit, AfterViewChecked {
  private readonly host = inject(ElementRef);
  private readonly destroyRef = inject(DestroyRef);
  private paginatorSentinelTracked = false;

  readonly engagements = input.required<EngagementListItem[]>();
  readonly listStatus = input.required<LoadableStatus>();
  readonly paginationOptions = input.required<PaginationOptions>();
  readonly searchControl = input.required<UntypedFormControl>();

  readonly cardClick = output<EngagementListItem>();
  readonly pageChange = output<PageEvent>();

  readonly LoadableStatus = LoadableStatus;

  @ViewChild('searchSentinel') searchSentinel: ElementRef<HTMLElement>;
  @ViewChild('paginatorSentinel') paginatorSentinel: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    const host = this.host.nativeElement as HTMLElement;
    const onScroll = () => this.updateSettled();
    
    host.addEventListener('scroll', onScroll, { passive: true });
    
    this.destroyRef.onDestroy(() => host.removeEventListener('scroll', onScroll));
    this.updateSettled();
  }

  ngAfterViewChecked(): void {
    if (this.paginatorSentinel && !this.paginatorSentinelTracked) {
      this.paginatorSentinelTracked = true;
      this.updateSettled();
    } else if (!this.paginatorSentinel) {
      this.paginatorSentinelTracked = false;
    }
  }

  private updateSettled(): void {
    const host = this.host.nativeElement as HTMLElement;

    if (this.searchSentinel) {
      const sentinelRect = this.searchSentinel.nativeElement.getBoundingClientRect();
      const hostRect = host.getBoundingClientRect();
      this.searchSentinel.nativeElement.nextElementSibling?.classList.toggle('settled', sentinelRect.top >= hostRect.top);
    }

    if (this.paginatorSentinel) {
      const atBottom = host.scrollHeight - host.scrollTop - host.clientHeight < 1;
      this.paginatorSentinel.nativeElement.previousElementSibling?.classList.toggle('settled', atBottom);
    }
  }
}
